// import Vue from 'vue';
import axios from "./lib/axios";
import qs from "qs";
// import countryObj from './lib/local/country'
import { Icon, Message, MessageBox, CollapseTransition } from "element-ui";
import Cookie from "./lib/dialog/cookies";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/base.css";
// import 'https://karyshop.oss-eu-central-1.aliyuncs.com/js/3.0.2_vue-router.js';
// import 'https://karyshop.oss-eu-central-1.aliyuncs.com/js/axios_0.18.0_axios.js';
// import 'https://karyshop.oss-eu-central-1.aliyuncs.com/js/vue_2.5.7_vue.js';
// import 'https://karyshop.oss-eu-central-1.aliyuncs.com/js/vuex_3.0.1_vuex.js';
Vue.use(axios);

Vue.use(Icon);
// 获取当前日期
function getData() {
  const now = new Date();
  const year = now.getFullYear(); // 年
  const month = now.getMonth() + 1; // 月
  const date = now.getDate(); // 日

  const time = `${year}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`
  return time
}
// 获取当前时分秒
function getTiemms() {
  const now = new Date();
  const hour = now.getHours();
  const padZero = num => String(num).padStart(2, '0');
  const formattedTime = `${padZero(hour)}:00:00`;

  return formattedTime
}
function gettoDayaddnoe() {
  var today = new Date(); // 获取当前日期和时间
  var tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000); // 获取明天的日期，通过增加一天的毫秒数来实现

  var tomorrowYear = tomorrow.getFullYear(); // 获取明天的年份
  var tomorrowMonth = tomorrow.getMonth() + 1; // 获取明天的月份（注意月份是从 0 开始计数的，所以需要加 1）
  var tomorrowDate = tomorrow.getDate(); // 获取明天的日期

  var tomorrowFormatted = tomorrowYear + '-' + addLeadingZero(tomorrowMonth) + '-' + addLeadingZero(tomorrowDate); // 格式化为 'YYYY-MM-DD' 的日期字符串

  return tomorrowFormatted
}
// 辅助函数：为单个数字添加前导零
function addLeadingZero(number) {
  return number < 10 ? '0' + number : number;
}

// 获取url所有参数
function getUrlParams() {
  const url = window.location.href;
  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split("?")[1];
  if (!urlStr) {
    return false;
  }
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split("&");
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split("=");
    obj[arr[0]] = decodeURI(arr[1]);
  }
  return obj;
}
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.prototype.$getUrlParams = getUrlParams;
Vue.prototype.$getTiemms = getTiemms;
Vue.prototype.$getData = getData;
Vue.prototype.$gettoDayaddnoe = gettoDayaddnoe;
Vue.prototype.$message = Message;

// window.JOperateInterface.init({
//   appKey: "314e9738070cda108fca675e", // 必填，此 appkey 须已绑定数据源，获取详情参考上文「获取应用信息」
//   debugMode: false, // 设置是否开启 debug 模式。true 则会打印更多的日志信息。设置 false 则只会输出 w、e 级别的日志
//   channel: "default-channel", // 渠道名称，默认值为:default-channel
// });
window.JAnalyticsInterface.init({
  appkey: "314e9738070cda108fca675e", // 极光官网中创建应用后分配的 appkey，必填
  debugMode: false, // 设置是否开启 debug 模式。true 则会打印更多的日志信息。设置 false 则只会输出 w、e 级别的日志。
  channel: "default-channel", // 渠道名称，默认值为:default-channel
  loc: true, //设置是否尝试获取位置信息上报，默认为 true
  singlePage:false //设置是否为单页面，默认为 false
});

const nav = window.navigator;
const localStorage = window.localStorage;
const sessionStorage = window.sessionStorage;
const local = window.location;
const cookiesLanguage = localStorage.getItem("cookiesChange");
const localCountry = localStorage.getItem("COUNTRY");
const language_type = localStorage.getItem("localLang") || "en";
const urlReg = /\/(register|login|reset_password)/;

// 获取本地存储的语言
const getLang = () => {
  let lang = (nav.language || nav.userLanguage).substr(0, 2);
  if (lang != language_type) {
    return [true, lang];
  }
  return [false, lang];
};
const toLang = () => {
  if (!sessionStorage.getItem("ischange")) {
    sessionStorage.setItem("ischange", "1");
    let reg = /\/cn/;
    let href = "";
    if (!reg.test(local.href)) {
      if (local.pathname.indexOf("/nl") >= 0) {
        let path = local.pathname.replace("/nl", "/cn");
        href = `${local.origin}${path}`;
      } else {
        href = `${local.origin}/cn${local.pathname}`;
      }
      local.href = href;
    }
  }
};

function changeLang() {
  if (urlReg.test(local.href)) return;
  let lang = getLang();
  let localLang = localStorage.getItem("localLang");
  // if (localLang && localLang === 'zh' && !sessionStorage.getItem('ischange')) {
  //   // 设置为中文
  //   toLang();
  //   return;
  // } else if (localLang && localLang === 'en') {
  //   return;
  // }
  let langReg = /\/cn/;
  let href = "";
  // 切换成nl
  if (
    lang[0] &&
    lang[1] == "nl" &&
    !localLang &&
    !langReg.test(local.href) &&
    local.pathname.indexOf("/nl") == -1
  ) {
    MessageBox.confirm(
      "We have detected that your browser language is Chinese. Do you want to switch languages?",
      "prompt",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }
    )
      .then(() => {
        localStorage.setItem("localLang", lang[1]);
        let path = local.pathname != "/" ? local.pathname : "";
        href = `${local.origin}/nl${path}`;
        local.href = href;
      })
      .catch((err) => {
        sessionStorage.setItem("ischange", true);
      });
    return;
  }
  // 切换成en
  if (lang[0] && lang[1] == "en" && !localLang && !langReg.test(local.href)) {
    MessageBox.confirm("检测到您的浏览器语言是英文，是否切换语言?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    })
      .then(() => {
        localStorage.setItem("localLang", 'en');
        let path = local.pathname != "/" ? local.pathname : "";
        href = `${local.origin}/en${path}`;
        local.href = href;
      })
      .catch((err) => {
        sessionStorage.setItem("ischange", true);
      });
    return;
  }
  // 取缓存
  if (localLang && localLang != "nl" && localLang != "en" && !langReg.test(local.href)) {
    console.log(localLang, "localLanglocalLang");
    MessageBox.confirm(
      `检测到您的浏览器语言是${localLang == "cn" ? "中文" : localLang == "en" ? "英文" : "荷兰语"
      }，是否切换语言?`,
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }
    )
      .then(() => {
        localStorage.setItem("localLang", localLang);
        let path = local.pathname != "/" ? local.pathname : "";
        href = `${local.origin}/${localLang}/${path}`;
        local.href = href;
      })
      .catch((err) => {
        sessionStorage.setItem("ischange", true);
      });
    return;
  }
  // 如果本地语言是中文，路由不是中文，没有切换语言，则显示是否切换语言
  if (lang[0] && lang[1] == "zh" && !localLang && !langReg.test(local.href)) {
    MessageBox.confirm("检测到您的浏览器语言是中文，是否切换语言?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    })
      .then(() => {
        localStorage.setItem("localLang", "cn");
        let path = local.pathname != "/" ? local.pathname : "";
        href = `${local.origin}/cn${path}`;
        local.href = href;
        // toLang();
      })
      .catch((err) => {
        localStorage.setItem("localLang", "en");
        sessionStorage.setItem("ischange", true);
      });
  }
}
// cookies切换语言
// if (!cookiesLanguage && !urlReg.test(local.href)) {
//   Cookie(() => {
//     changeLang();
//   });
// } else {
//   changeLang();
// }
function parseQuery() {
  let search = local.search.replace(/&amp;/g, "");
  return qs.parse(search.replace("?", ""));
}

// currentPage 改变时回调
function changePage(page) {
  const params = parseQuery();
  params.page = page;

  local.replace(`${local.origin}${local.pathname}?${qs.stringify(params)}`);
}
// pageSize 改变时回调
function changeSize(size) {
  const params = parseQuery();
  params.size = size;
  local.replace(`${local.origin}${local.pathname}?${qs.stringify(params)}`);
}

Vue.prototype.parseQuery = parseQuery;
Vue.prototype.changePage = changePage;
Vue.prototype.changeSize = changeSize;
// Vue.prototype.changeLang = changeLang;
export default Vue



// WEBPACK FOOTER //
// ./resources/js/main.js